import { SUBSCRIPTION_INTERVAL } from "shared/enums/common.enum";

export class ChangeSubscriptionPlanRequestDTO{
    interval!: SUBSCRIPTION_INTERVAL;

    constructor(data: ChangeSubscriptionPlanRequestDTO){
        Object.assign(this, data);
    }
}